"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
var _MenuPropTypes = require("./MenuPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MenuItemIcon = _ref => {
  let {
    icon,
    isOpen,
    isHoverTrigger = false
  } = _ref;
  if (!icon) {
    return null;
  }
  const {
    open,
    closed
  } = icon;
  const RenderIcon = (icon, hoverState) => {
    if (typeof icon === 'string') {
      return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        customCssClass: hoverState ? 'hover' : '',
        icon: icon
      });
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "menuIconElementWrapper"
    }, icon);
  };
  if (isHoverTrigger) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "menuIconsHoverWrapper"
    }, RenderIcon(open, true), RenderIcon(closed));
  }
  if (open && closed) {
    if (isOpen) {
      return RenderIcon(open);
    }
    return RenderIcon(closed);
  }
  return RenderIcon(icon);
};
exports.MenuItemIcon = MenuItemIcon;
MenuItemIcon.propTypes = {
  icon: _MenuPropTypes.MenuItemIconPropTypes,
  isOpen: _propTypes.default.bool,
  isHoverTrigger: _propTypes.default.bool
};